import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'botao-voltar',
  templateUrl: './botao-voltar.component.html',
  styleUrls: ['./botao-voltar.component.css']
})
export class BotaoVoltarComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit(): void {
  }

  voltarPaginaAnterior(){
    this.location.back();
  }
}
